/**
 * Leveringslinje (grøn prik) – langaa-larsen.dk
 * Version 2.1
 *
 * Funktioner:
 * - Én linje med grøn prik og leveringstekst (matcher dit ønskede design).
 * - Viser dato baseret på deadlines, weekender og helligdage.
 * - Viser produktionstid for bestillingsvarer.
 * - Viser ferie/lukket-meddelelse hvis konfigureret.
 */

document.addEventListener('DOMContentLoaded', function () {
  // --- KONFIGURATION ---
  const CONFIG = {
    deadlineHour: 14,   // Bestil inden kl. 14
    deadlineMinute: 0,
    isClosedUntil: null, // 'YYYY-MM-DD' for ferie/lukket, eller null for normal drift

    // Tekster
    productionTimeText: "3-5 hverdage",
    closedHeadline: "Vi holder midlertidigt lukket",
    get closedMessage() {
      const date = new Date(this.isClosedUntil + 'T00:00:00');
      const friendlyDate = date.toLocaleDateString('da-DK', { day: 'numeric', month: 'long' });
      return `Vi sender igen fra d. ${friendlyDate}.`;
    },

    // Danske helligdage (MM-DD)
    holidays: [
      '01-01', // Nytårsdag
      '04-17', // Skærtorsdag 2025
      '04-18', // Langfredag 2025
      '04-21', // 2. Påskedag 2025
      '05-16', // Store Bededag
      '05-29', // Kristi Himmelfartsdag
      '06-09', // 2. Pinsedag
      '12-24', // Juleaften
      '12-25', // 1. Juledag
      '12-26', // 2. Juledag
      '12-31'  // Nytårsaftensdag
    ],

    // Container IDs (skal matche dem i main-product.liquid)
    stockElementId: 'delivery-info-container',
    productionElementId: 'delivery-info-container-production'
  };
  // --- SLUT KONFIGURATION ---

  // Utils
  function isHoliday(date) {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return CONFIG.holidays.includes(`${month}-${day}`);
  }

  function addWorkdays(date, days) {
    let d = new Date(date);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const dow = d.getDay();
      if (dow !== 0 && dow !== 6 && !isHoliday(d)) {
        added++;
      }
    }
    return d;
  }

  function formatDateLongDa(d) {
    const weekday = d.toLocaleDateString('da-DK', { weekday: 'long' });
    const day     = d.getDate();
    const month   = d.toLocaleDateString('da-DK', { month: 'long' });
    return `${capitalize(weekday)} d. ${day}. ${month}`;
  }

  function capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Render: én linje med grøn prik + tekst
  function renderLine(target, text) {
    if (!target) return;
    target.innerHTML = `
      <div class="delivery-banner" style="display:flex;align-items:center;gap:12px;padding:8px 0 12px;border-bottom:2px solid rgba(0,0,0,.08);font-size:18px;line-height:1.4;color:#2b2b2b;">
        <span aria-hidden="true" class="delivery-banner__dot" style="width:12px;height:12px;border-radius:50%;background:#3ED660;flex:0 0 12px;display:inline-block;"></span>
        <span class="delivery-banner__text" style="font-weight:500;">${text}</span>
      </div>
    `;
  }

  // Hovedlogik
  const stockEl = document.getElementById(CONFIG.stockElementId);
  const prodEl  = document.getElementById(CONFIG.productionElementId);

  // 1) Ferie/lukket
  if (CONFIG.isClosedUntil) {
    const line = `${CONFIG.closedHeadline} – ${CONFIG.closedMessage}`;
    renderLine(stockEl, line);
    renderLine(prodEl, line);
    return;
  }

  // 2) Produktions-/bestillingsvarer
  if (prodEl) {
    renderLine(prodEl, `Forventet levering: ${CONFIG.productionTimeText}`);
  }

  // 3) Lagervarer
  if (stockEl) {
    const now = new Date();
    const dow = now.getDay();
    const isWeekday = dow > 0 && dow < 6;
    const beforeDeadline =
      now.getHours() < CONFIG.deadlineHour ||
      (now.getHours() === CONFIG.deadlineHour && now.getMinutes() < CONFIG.deadlineMinute);

    let workdaysToAdd;
    if (isWeekday && beforeDeadline) {
      workdaysToAdd = 1; // bestilt inden deadline
    } else if (isWeekday && !beforeDeadline) {
      workdaysToAdd = 2; // efter deadline
    } else {
      workdaysToAdd = 2; // weekend
    }

    const delivery = addWorkdays(now, workdaysToAdd);
    const line = `Din ordre leveres ${formatDateLongDa(delivery)}`;
    renderLine(stockEl, line);
  }
});
